






import Vue from "vue";
import { Component } from "vue-property-decorator";
import Game, { GameType } from "@/components/Game.vue";
import views from "@/views/Views";

@Component({
  components: {
    Game,
  },
})
export default class WeightsPath extends Vue {
  type: GameType = GameType.WEIGHTSPATH;
  title = views.find((el) => el.component === GameType.WEIGHTSPATH).title;
  video = "normalto.mp4";
}
